import React, { useCallback } from 'react';

import { useCreateCompetition } from '@pkg/hooks';

import { type CreateCompetition } from '@app/client';

import { GameForm } from '../GameForm';

export const useHandleCreateCompetition = (onSuccess?: (slug: string) => void) => {
    const { mutateAsync, isPending } = useCreateCompetition();

    return useCallback(
        (gameData: CreateCompetition) => {
            if (isPending) return;
            mutateAsync(gameData).then(async (res) => {
                if (!res.ok) {
                    alert(res.error);
                }
                if (res && res.ok) {
                    onSuccess?.(res.value.slug);
                }
            });
        },
        [isPending, mutateAsync, onSuccess],
    );
};

interface CreateGameProps {
    onSuccess?: (slug: string) => void;
}

export const CreateGame = ({ onSuccess }: CreateGameProps) => {
    const createCompetition = useHandleCreateCompetition(onSuccess);

    // This has been temporarily added in response to ticket https://tari.atlassian.net/browse/HR-4020
    // Once Fantasy is relaunched, we can completely remove 'isNewFantasyGameDisabled' and 'fantasyTemporaryAlertMarkup'
    const isNewFantasyGameDisabled = true;

    const fantasyTemporaryAlertMarkup = isNewFantasyGameDisabled ? (
        <div
            style={{
                backgroundColor: '#ffd222',
                borderRadius: 12,
                color: '#000',
                lineHeight: 2,
                margin: '30px 0',
                padding: '20px',
            }}
        >
            <div style={{ fontWeight: 'bold' }}>🚫 New games are currently not allowed.</div>
            <div>This feature will be turned back on once Product has announced that Fantasy is relaunching.</div>
            <div style={{ fontWeight: 'bold' }}>
                This restriction is hard-coded and does not respond to the &lsquo;Yat Fantasy_23 Archive&rsquo; feature
                flag.
            </div>
            <div>
                For more information, please contact @
                <a href="https://nomatter.tari.com/tari/messages/@djangolin" style={{ textDecoration: 'underline' }}>
                    djangolin
                </a>
                .
            </div>
        </div>
    ) : null;

    return (
        <>
            {fantasyTemporaryAlertMarkup}
            <GameForm onCreate={createCompetition} isDisabled={isNewFantasyGameDisabled} />
        </>
    );
};
